<template>

  <div v-bind:class="get_width('feedback')" v-bind:key="pos[3]">

    <div class="hit-panel hit-panel-primary">
      <div class="hit-panel-heading">
        <div class="hit-pull-right">{{ $tc("message.feedback", 2) }}</div>
        <span class="handle"><i class="hit-glyphicon hit-glyphicon-move"></i></span>
      </div>
      <div class="hit-panel-body" style="background-color: lightgrey;">
        <div class="hit-form-group" v-bind:key="curr_key+'_votes'" >

          <hit_votes :key="check_data()"  :design="design.votings" :survey="Object.assign(board[$route.params.boardID], {colors: colors})" />

        </div>
      </div>
      <div class="hit-panel-footer hit-text-right">
        <div class="hit-row">
          <div class="hit-col-md-6">
            <select class="hit-form-control" v-model="design.votings">
              <option v-for="name in Object.keys($store.getters.votings)" v-bind:value="name">{{ $t("message."+name.toLowerCase()) }}</option>
            </select>
          </div>
          <div class="hit-col-md-6">
            <select class="hit-form-control" v-bind:value="width['feedback']" v-on:change="function(val){ set_width(val.target.value, 'feedback') }">
              <option v-for="col in [12,11,10,9,8,7,6,5,4,3,2,1]" v-bind:value="col">{{ Math.round((col/12 * 100)) }}%</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default{

  props: {
    width: Object,
    set_width: Function,
    board: Object,
    colors: Object,
    design: Object,
    curr_key: [String, Number],
    get_width: Function,
    get_badge: Function,
    pos: Array

  },

  methods:{

    check_data(){


      if( typeof this.board == "undefined" || typeof this.board[this.$route.params.boardID] == "undefined" )
        return false;

      if(typeof this.colors != "undefined" && typeof this.colors.md5_id == "string")
        this.board[this.$route.params.boardID].user = this.colors.md5_id;


      return true;
    }
  }
}



</script>

<style scoped>

.handle{
  cursor: pointer;
}

</style>
